module.exports = __webpack_public_path__ + "static/img/Visualization12.eda4e794.png";